// Auto-import SASS generated CSS
import './index.css';

export type {IconDropdownProps, IconDropdownOption} from './IconDropdown';
export {default as default} from './IconDropdown';
